import { useCallback, useContext, useEffect, useState } from 'react';

import { SingleAssignmentFragment } from '../../../graphql/generated/graphql_offer';
import { context as DependencyContext } from '../../context/dependency';

const useMyAssignmentsQuery = (_filterState: string) => {
  const filterState = _filterState.toUpperCase();
  const dependency = useContext(DependencyContext);

  const [res, setRes] = useState<{ items: SingleAssignmentFragment[] | null; endCursor: string | null }>({
    items: null,
    endCursor: null,
  });
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(0);
  const fetchData = useCallback(
    async (cursor: string | null, items: SingleAssignmentFragment[]) => {
      setLoading((loading) => ++loading);
      const res = await dependency.offer.assignmentWebApi.search(filterState, cursor);
      setRes({
        ...res,
        items: items.concat(res.items),
      });
      setLoading((loading) => --loading);
    },
    [dependency.offer.assignmentWebApi, filterState],
  );
  const fetchCount = useCallback(async () => {
    setLoading((loading) => ++loading);
    const count = await dependency.offer.assignmentWebApi.getCount(filterState);
    setCount(count);
    setLoading((loading) => --loading);
  }, [dependency.offer.assignmentWebApi, filterState]);

  useEffect(() => {
    fetchCount();
  }, [fetchData, fetchCount]);

  const loadMore = () => {
    fetchData(res.endCursor, res.items || []);
  };
  return { count, items: res.items, loading: loading > 0, hasNext: !!res.endCursor, loadMore };
};

export default useMyAssignmentsQuery;
